import axios from 'axios';

export class Messages {
  static async postSlack(
    text: string,
    channel: string,
    username: string,
    pa_url = 'https://hooks.slack.com/services/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'
  ): Promise<string> {
    const url = pa_url;
    const data = `payload={
      "channel": "${channel}",
      "username": "${username}",
      "text": "${text}",
    }`;
    //      "icon_emoji":"${iconEmoji}"

    const param = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    };
    await axios.post(url, data, param);
    return 'ok';
  }
}
